import "../../index22.css";
import { jsx as m } from "react/jsx-runtime";
import { _ as c } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
const _ = "_description_1x4h0_1", d = "_with-centered-content_1x4h0_4", l = "_text-size-small_1x4h0_10", a = "_text-size-medium_1x4h0_14", z = "_text-size-large_1x4h0_18", S = "_with-light-text_1x4h0_22", t = {
  description: _,
  withCenteredContent: d,
  textSizeSmall: l,
  textSizeMedium: a,
  textSizeLarge: z,
  withLightText: S
};
function u(i) {
  const {
    className: n,
    children: s,
    withCenteredContent: o,
    elementRef: r,
    textSize: e = "md",
    withLightText: x,
    ...h
  } = i;
  return /* @__PURE__ */ m(
    "div",
    {
      ...h,
      ref: r,
      className: c(
        t.description,
        o && t.withCenteredContent,
        e === "sm" && t.textSizeSmall,
        e === "md" && t.textSizeMedium,
        e === "lg" && t.textSizeLarge,
        x && t.withLightText,
        n
      ),
      children: s
    }
  );
}
export {
  u as default
};
